import { useEvent } from "event/hooks/useEvent";

import type { Event } from "event/types/event.model";
import type { Message } from "wall/types/message.model";

import { UseFormReturnType } from "@mantine/form";

import { ListNavigation } from "./ListNavigation";
import "event/play/common/PronosticView.css";
import "./Header.css";
import { useSavedEvent } from "../../hooks/useSavedEvent";

import { useEffect, useState } from "react";
import { useMantineTheme } from "@mantine/core";
import { TransperentNavigation } from "./TransperentNavigation";

type PSGHeaderProps = {
  form?: UseFormReturnType<
    Partial<Message>,
    (values: Partial<Message>) => Partial<Message>
  >;
  setIsMessageSent?: React.Dispatch<React.SetStateAction<boolean>>;
};

export function replacePlaceholders(
  template: string,
  mainName: string,
  mainVisual: string,
  opponentName: string,
  opponentVisual: string,
  backgroundColor: string,
  textColor: string,
) {
  return template
    .replace(/#MAIN_NAME#/g, mainName)
    .replace(/#MAIN_VISUAL#/g, mainVisual)
    .replace(/#OPPONENT_NAME#/g, opponentName)
    .replace(/#OPPONENT_VISUAL#/g, opponentVisual)
    .replace(/#BACKGROUND_COLOR#/g, backgroundColor)
    .replace(/#TEXT_COLOR#/g, textColor);
}

export function Header2({ form, setIsMessageSent }: PSGHeaderProps) {
  const event: Event | undefined = useEvent();
  // const getEventQuery = useGetEventQuery(event?.id ?? skipToken);
  const [savedEvent] = useSavedEvent(event?.id!);
  const [isHomePage, setIsHomePage] = useState(false);
  const [header, setHeader] = useState("");
  // theme by hook
  const theme = useMantineTheme();
  const isTransperent =
    event?.navigation?.navigationType ===
    ("transparent" as "transperent" | "default");

  useEffect(() => {
    const eventHomePage = document.getElementById("EventHomePage");
    if (eventHomePage) {
      setIsHomePage(true);
    }
  }, []);
  useEffect(() => {
    const modifiedHeader = replacePlaceholders(
      event?.header!.html!,
      event?.team_name!,
      event?.images.teamLogo!,
      event?.opponent.name!,
      event?.opponent.logo!,
      event?.colors?.headerBackground!,
      event?.colors?.headerEventText!,
    );
    setHeader(modifiedHeader);
  }, [event]);

  if (!event) {
    return <></>;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        fontFamily: theme.fontFamily,
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: header }} />
      {savedEvent && isHomePage && !isTransperent && (
        <ListNavigation
          event={event}
          form={form}
          open={true}
          setIsMessageSent={setIsMessageSent}
        />
      )}
      {savedEvent && isHomePage && isTransperent && (
        <TransperentNavigation
          event={event}
          form={form}
          open={true}
          setIsMessageSent={setIsMessageSent}
        />
      )}
      {savedEvent && !isHomePage && !isTransperent && (
        <ListNavigation
          event={event}
          form={form}
          open={false}
          setIsMessageSent={setIsMessageSent}
        />
      )}
      {savedEvent && !isHomePage && isTransperent && (
        <TransperentNavigation
          event={event}
          form={form}
          open={false}
          setIsMessageSent={setIsMessageSent}
        />
      )}
    </div>
  );
}
